/**
 * A "live" marker: a solid dot with halo rings that keep swelling out of it and
 * fading, so the entry it labels reads as a feed that is running now.
 *
 * Modelled on LottieFiles' "Live dot" (3V8y4Vw1lL), redrawn in CSS rather than
 * shipped as Lottie: a player runtime for one icon is not worth the bundle, and
 * the colour has to follow `--primary`, which users can change at runtime.
 * Motion is in `styles/index.css` under `.live-dot`.
 */
interface LiveDotProps {
  /** Box edge in px; the outermost ring reaches it. */
  size?: number;
}

export function LiveDot({ size = 20 }: LiveDotProps): JSX.Element {
  return (
    <span className="live-dot" style={{ width: size, height: size }} aria-hidden="true">
      <span className="live-dot__ring" />
      <span className="live-dot__ring" />
      <span className="live-dot__core" />
    </span>
  );
}
